/**
 * Web home alert-strip inputs (R2 dedupe — combined-CHECK §2-R2).
 *
 * During a storm the layout `HurricaneBanner` always renders and carries the
 * storm; feeding `storm` into the greeting-row `AlertStatusStrip` too would
 * duplicate that banner ~100px above it AND permanently demote every
 * persona-specific alert (the exact D5 signal the strip exists to surface).
 * So the WEB home strip EXCLUDES storm and headlines the next-highest persona
 * condition (outage > demand > anomaly), falling back to the quiet "Power on".
 *
 * The shared `resolveHomeAlerts` resolver is UNTOUCHED — it still ranks storm
 * for the Phase-3 mobile home, which has no banner. This helper is web-only and
 * simply never passes `storm`, so the exclusion can't be reintroduced by a
 * call-site edit (its arg type carries no storm field) and stays unit-pinnable.
 */
import type { HomeAlertInputs } from "@petci/shared-ui";

export interface WebHomeAlertArgs {
  outage: { active: boolean; circuitName?: string | undefined; outageId?: string | undefined };
  demandNearThreshold: boolean;
  anomaly: { count: number; accountNumber?: string | undefined };
}

/** Build the web home strip inputs, deliberately omitting `storm` (R2). */
export function webHomeAlertInputs(args: WebHomeAlertArgs): HomeAlertInputs {
  return {
    outage: args.outage,
    demandNearThreshold: args.demandNearThreshold,
    anomaly: args.anomaly,
  };
}
